export default "__VITE_ASSET__BbrDqpaX__"